import { Children, ReactNode, RefObject } from 'react';

import { ActionBar, FilterBar } from '@spotify/confidence-core-react';

import { FiltersProvider } from '../Wrapper';
import { WrapperEntry } from '../Wrapper/composition';

type UseActionBarArgs = {
  wrapperElements: WrapperEntry[];
  actionBar: ReactNode;
  actionBarRef: RefObject<HTMLDivElement | null>;
  actionBarTopOffset: number;
};

export const useActionBar = ({
  wrapperElements,
  actionBar,
  actionBarRef,
  actionBarTopOffset,
}: UseActionBarArgs): ReactNode => {
  const hasFiltersProvider = wrapperElements.some(
    entry => entry.element.type === FiltersProvider,
  );

  if (!actionBar && !hasFiltersProvider) return null;

  const userActions = Children.toArray(actionBar);
  const filterBarHasNoSiblings = hasFiltersProvider && userActions.length === 0;

  const actionBarChildren = hasFiltersProvider
    ? [
        <FilterBar key="auto-filter-bar" />,
        ...userActions,
        ...(filterBarHasNoSiblings
          ? [<span key="end-anchor" aria-hidden />]
          : []),
      ]
    : actionBar;

  return (
    <ActionBar ref={actionBarRef} topOffset={actionBarTopOffset}>
      {actionBarChildren}
    </ActionBar>
  );
};
